var _style, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-424.5 -21.5 404 404",
    style: {
      enableBackground: "new -424.5 -21.5 404 404"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F05133;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: -222.5,
    cy: 180.5,
    r: 192.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-107,169.8L-211.8,65c-6-6-15.8-6-21.9,0l-21.8,21.8l27.6,27.6c6.4-2.2,13.8-0.7,18.9,4.4 c5.1,5.1,6.6,12.6,4.4,19l26.6,26.6c6.4-2.2,13.9-0.8,19,4.4c7.2,7.2,7.2,18.8,0,26c-7.2,7.2-18.8,7.2-26,0c-5.4-5.4-6.7-13.3-4-20 l-24.8-24.8v65.3c1.7,0.9,3.4,2,4.9,3.5c7.2,7.2,7.2,18.8,0,26c-7.2,7.2-18.8,7.2-26,0c-7.2-7.2-7.2-18.8,0-26c1.8-1.8,3.8-3.1,6-4 v-65.9c-2.2-0.9-4.2-2.2-6-4c-5.4-5.4-6.7-13.4-4-20.1l-27.2-27.2l-71.9,71.8c-6,6-6,15.8,0,21.9L-233.2,296c6,6,15.8,6,21.9,0 L-107,191.7C-101,185.6-101,175.8-107,169.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitIcon);
export default __webpack_public_path__ + "static/media/git-icon.a600ec0ca11ef988d95a03c52d0b4dc8.svg";
export { ForwardRef as ReactComponent };